document.addEventListener("DOMContentLoaded", function() {
    // Fonction pour modifier les textes après chargement du script externe
    function updateCreditTexts() {
        // Modifier le texte "Pay with store credit"
        var payWithCreditElement = document.querySelector('.binderpos-credit-input-div p');
        if (payWithCreditElement) {
            // Conserver le contenu dynamique
            var dynamicContent = payWithCreditElement.querySelector('span.creditBlock');
            var dynamicText = dynamicContent ? dynamicContent.outerHTML : '';
            payWithCreditElement.innerHTML = "<i class='fas fa-money-check-alt'></i> Payer avec le crédit magasin " + dynamicText;
        }

        // Modifier le texte dynamique "$x available"
        var availableCreditElement = document.querySelector('.creditBlock');
        if (availableCreditElement) {
            var creditValue = availableCreditElement.textContent.match(/\$[\d.]+/)[0]; // Extraire la valeur du crédit
            availableCreditElement.textContent = `${creditValue} disponible`;
        }

        // Modifier le texte "Enter the amount you want to use"
        var enterAmountElement = document.querySelector('.binderpos-credit-use-div label');
        if (enterAmountElement) {
            enterAmountElement.textContent = "Entrez le montant que vous souhaitez utiliser";
        }

        // Modifier le texte "Validating your store credit..."
        var validatingText = document.querySelector('.binderpos-store-credit-loader-text');
        if (validatingText) {
            validatingText.textContent = "Validation de votre crédit magasin...";
        }
    }

    // Attendre que le script externe soit chargé et ensuite exécuter la fonction
    setTimeout(updateCreditTexts, 1250); // Ajuster le délai si nécessaire
});
